import InventoryQuickAssign from './InventoryQuickAssign';
export default InventoryQuickAssign;
